import { news } from "./constants";
import axios from "../axios";

export const getNews = (language, offset = 0) => {
  return async (dispatch) => {
    try {
      dispatch({ type: news.GET_NEWS_REQUEST });
      const res = await axios.get(
        `${language}/api/news/?limit=20&offset=${offset}`
      );
      if (res.status === 200 || res.status === 201) {
        dispatch({
          type: news.GET_NEWS_SUCCESS,
          payload: {
            news: res.data,
          },
        });
      }
    } catch (error) {
      dispatch({ type: news.GET_NEWS_FAILURE });
    }
  };
};
